import { firebaseShared } from "@shared/firebase.js";
import * as firebase from "@shared/firebase.js";
import * as environment from "@shared/environment.js";
import { dlog } from "@shared/utility.js";

let allRenderSpecs = [];

function renderSpecWithID(id) {
    return allRenderSpecs.find(item => item.id === id);
}

function getAllRenderSpecs() {
    return allRenderSpecs ? [...allRenderSpecs] : [];
}

async function fetchRenderSpecs(force = false) {
    if (!force && allRenderSpecs.length > 0) {
        dlog("already fetched render specs. bailing.");
        return;
    }

    try {
        dlog(`fetchRenderSpecs: start; collection: ${environment.currentRenderSpecCollectionName()}`);

        const collectionRef = firebase.collection(firebaseShared.db, environment.currentRenderSpecCollectionName());
        dlog(`fetchRenderSpecs: got collectionRef`);

        const snapshot = await firebaseShared.withRetry(() => firebase.getDocs(collectionRef));
        dlog(`fetchRenderSpecs: got snapshot`);

        const tempSpecs = [];

        snapshot.forEach(doc => {
            tempSpecs.push(doc.data());
        });

        allRenderSpecs = tempSpecs;
        dlog("allRenderSpecs count: " + allRenderSpecs.length);
    } catch (error) {
        console.warn("fetchRenderSpecs failed after retries:", error);
        return;
    }

    dlog(`fetchRenderSpecs: ${allRenderSpecs.length} items in collection`);
}

export { renderSpecWithID, fetchRenderSpecs, getAllRenderSpecs };
